import React from 'react';


const Citizenship: React.FC = () => {
    return (
        <section id="citizenship" className='pdtopBottmSection'>
            <div className="container reveal">
            <div className="citizenship-text">
                <div className="section-label">Turkish Passport</div>
                <h2>Invest Today. <em>Passport</em><br/>Tomorrow.</h2>
                <p>Turkey’s citizenship-by-investment programme grants full passport eligibility at a qualifying real estate purchase threshold. INVESTA ESTATES guides clients from property selection through transaction coordination and onward process support.</p>
            </div>
            <div className="citizenship-pill">
                <div className="citizenship-pill-amount">$400K</div>
                <div className="citizenship-pill-label">Minimum Investment<br />for Turkish Citizenship</div>
            </div>
            </div>
        </section>
    )
}   

export default Citizenship;


